import { Injectable } from '@angular/core';
import { ApiCallBase } from '../apiCallBase';
import { LanguageService } from '../../language/language.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { API_V3_URL } from 'src/app/config/config';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManageAccountService extends ApiCallBase {
  correctedLanguage = 'EN-US';
  constructor(
    public languageService: LanguageService,
    public http: HttpClient,
    public router: Router,
  ) {
    super(languageService, http, router);
    this.correctedLanguage = this.language === 'es' ? 'ES-LA' : 'EN-US';
  }

  accountDataDeletionRequest(body: { email: string; language: string }) {
    body.language = this.correctedLanguage;
    const url = `${API_V3_URL}/auth/account-data-deletion-request`;
    return this.http.post(url, body, this.getHttpOptionsWithoutTokenV3()).pipe(
      catchError((error) => {
        throw error;
      }),
    );
  }

  accountDataDeletionComplete(payload: string) {
    const url = `${API_V3_URL}/auth/account-data-deletion-complete`;
    return this.http
      .post(url, { hash: payload }, this.getHttpOptionsWithoutTokenV3())
      .pipe(
        catchError((error) => {
          throw error;
        }),
      );
  }

  /** Get all the Login Types for a User
   * @param query Body of the request
   * @returns The Chat Session as an object
   */
  getUserLoginTypes(query: GetUserLoginTypes_Req): Observable<{
    login_types: {
      id: string;
      name: string;
    }[];
  }> {
    // return of({
    //   login_types: [
    //     {
    //       id: 'MICROSOFT',
    //       name: 'Microsoft',
    //     }
    //   ]
    // })

    const url = `${API_V3_URL}/auth/user-login-types`;
    const queryParameters = new HttpParams({
      fromObject: query,
    });
    const apiV3Options = {
      ...this.getHttpOptionsWithoutTokenV3(),
      params: queryParameters,
    };

    const res = this.http.get<GetUserLoginTypes_Res>(url, apiV3Options).pipe(
      map((res) => res.response),
      catchError((error) => {
        console.error('Error retrieving a User Login Types: ', error);
        throw error;
      }),
    );

    return res;
  }
}

//* ---- Get Chat Session For TutorIA ----
export interface GetUserLoginTypes_Req {
  user_id: string;
  [param: string]:
    string | number | boolean | readonly (string | number | boolean)[];
}
export interface GetUserLoginTypes_Res {
  response: {
    login_types: {
      id: string;
      name: string;
    }[];
  };
}
